import { createSlice } from '@reduxjs/toolkit';

import { updateSearchParams } from '../common/reducers/updateSearchParams.reducers';

import { setOverrides, updateOverrides } from './reducers/desktop.settingsOverrides.reducers';
import { INITIAL_SENT_DOCUMENTS_STATE } from './sent.state';

const slice = createSlice({
  name: 'sentDocuments',
  initialState: INITIAL_SENT_DOCUMENTS_STATE,
  reducers: {
    /*
     * DASHBOARD
     */

    /*
     * View
     */

    setOverrides: (state, action) => setOverrides(state, action),
    updateOverrides: (state, action) => updateOverrides(state, action),

    updateSearchParams,
  },
});

export const documentSentReducer = slice.reducer;

export const SentDocumentsActions = slice.actions;
